import { Injectable, ErrorHandler } from '@angular/core';
import * as Sentry from '@sentry/browser';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SentryService implements ErrorHandler {
  constructor() {}

  handleError(error: any): void {
    const exception = error.originalError || error;
    if (environment.production) {
      Sentry.captureException(exception);
    }
    console.error(exception);
  }
}
